<template>
    <div class="container"
    @wheel="roll_away"
    @touchstart="touchStartHandler"
    @touchend="touchEndHandler">
        <div class="main-box">
            <div class="up-svg-box">
                <div @click="page_turning(false)" class="up-svg">
                    <img src="../../assets/image/index_v2/down.svg" alt="">
                </div>
            </div>
            <div class="lucida-icon">
                <img src="../../assets/image/index_v2/Group.svg" alt="">
            </div>
            <div class="title">
                <div><span class="emphasize">Lucida is a</span></div>
                <div>multi-strategy</div>
                <div>hedge fund built</div>
                <div>for&nbsp;<span class="emphasize">Crypto trading</span></div>
            </div>
            <div class="user-info">
                <div class="info-item">
                    It has leading performance in <span>arbitrage,market-</span><br />
                    <span>making, and directional strategies.</span>
                </div>
                <div class="info-item">
                    Its team consists of over <span>20 experienced</span><br />
                    <span>researchers and asset managers</span> based in<br />
                    <span>Hong Kong, London and New York.</span>
                </div>
                <div class="info-item">
                    Lucida was founded in 2018<br />
                    by <span>Naiqian Zheng</span>
                </div>
                <div class="info-item">
                    and its co-managing partners is<br />
                    <span>Fabian Bjorklund</span>
                </div>
            </div>
            <div class="article">
                <div class="article-research">
                    <div class="article-type">Research</div>
                    <div class="article-list article-list-left"
                    ref="ResearchScroll" @scroll="handleScroll('Research')"
                    @mouseenter="mouseInListEnter(1)" @mouseleave="mouseInListLeave()">
                        <div v-for="groupItem in articleR" :key="'Research_Group_'+groupItem.groupId" class="article-item">
                            <div class="article-cover">
                                <div v-for="cover, index in groupItem.cover" :key="'Research_GroupCover_'+groupItem.groupId+'_'+index">
                                    <div v-if="index !== 0" class="cover-line"></div>
                                    <div @click="goto_url(groupItem.articleList[index].defaultLink)" class="article-cover-item">
                                        <img class="touch-target" :src="getCoverPath(cover)" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="article-info">
                                <div class="article-info-box" v-for="article,index in groupItem.articleList" :key="'Research_GroupArticle_' + groupItem.groupId + '_' + article.id">
                                    <div v-if="index !== 0" class="article-line"></div>
                                    <div @click="goto_url(article.defaultLink)" class="article-title">{{ article.title }}</div>
                                    <div class="article-date">
                                        {{ dateStrFormat(article.releaseDate) }}
                                        <img class="touch-target" v-for="linkItem, index in article.linkList"
                                        :key="'Research' + article.id + '-linkList-' + index"
                                        @click="goto_url(linkItem.link)"
                                        :src="getCoverPath(linkItem.logo)" alt="">
                                    </div>
                                    <div class="article-abstract">{{ article.articleAbstract }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="articleListParam['Research'].total === 0" class="skeleton">
                            <div class="article-skeleton" v-for="i in 4" :key="'Research-skeleton-' + i">
                                <div class="cover-skeleton">
                                    <img src="../../assets/image/index_v2/cover_load.svg" alt="">
                                </div>
                                <div class="context-skeleton">
                                    <div class="title-skeleton"></div>
                                    <div class="date-skeleton"></div>
                                    <div class="abstract-skeleton"></div>
                                    <div class="abstract-skeleton"></div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="next-page">
                            <span v-if="isLastPage('Research')">There are no more articles left...</span>
                            <img v-else src="../../assets/image/index_v2/load.svg" alt="">
                        </div>
                    </div>
                </div>
                <div class="article-apmv">
                    <div class="article-type">AMA & Podcast</div>
                    <div class="article-list article-list-right"
                    ref="AMAPodcastScroll" @scroll="handleScroll('AMA & Podcast')"
                    @mouseenter="mouseInListEnter(2)" @mouseleave="mouseInListLeave()">
                        <div v-for="groupItem in articleAMAP" :key="'AMAP_Group_' + groupItem.groupId" class="article-item">
                            <div class="article-cover">
                                <div v-for="cover, index in groupItem.cover" :key="'AMAP_GroupCover_'+groupItem.groupId+'_'+index">
                                    <div v-if="index !== 0" class="cover-line"></div>
                                    <div @click="goto_url(groupItem.articleList[index].defaultLink)" class="article-cover-item">
                                        <img class="touch-target" :src="getCoverPath(cover)" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="article-info">
                                <div class="article-info-box" v-for="article,index in groupItem.articleList" :key="'AMAP_GroupArticle_' + groupItem.groupId + '_' + article.id">
                                    <div v-if="index !== 0" class="article-line"></div>
                                    <div @click="goto_url(article.defaultLink)" class="article-title">{{ article.title }}</div>
                                    <div class="article-date">
                                        {{ dateStrFormat(article.releaseDate) }}
                                        <img class="touch-target" v-for="linkItem, index in article.linkList"
                                        :key="'AMAP' + article.id + '-linkList-' + index"
                                        @click="goto_url(linkItem.link)"
                                        :src="getCoverPath(linkItem.logo)" alt="">
                                    </div>
                                    <div class="article-abstract">{{ article.articleAbstract }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="articleListParam['AMA & Podcast'].total === 0" class="skeleton">
                            <div class="article-skeleton" v-for="i in 3" :key="'AMAPodcast-skeleton-' + i">
                                <div class="cover-skeleton">
                                    <img src="../../assets/image/index_v2/cover_load.svg" alt="">
                                </div>
                                <div class="context-skeleton">
                                    <div class="title-skeleton"></div>
                                    <div class="date-skeleton"></div>
                                    <div class="abstract-skeleton"></div>
                                    <div class="abstract-skeleton"></div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="next-page">
                            <span v-if="isLastPage('AMA & Podcast')">There are no more articles left...</span>
                            <img v-else src="../../assets/image/index_v2/load.svg" alt="">
                        </div>
                    </div>
                    <div class="article-type">Market View</div>
                    <div v-if="articleListMV.length > 0" class="article-item"
                    @mouseenter="mouseInListEnter(3)" @mouseleave="mouseInListLeave()">
                        <div @click="goto_url(articleListMV[0].defaultLink)" class="article-cover">
                            <div class="article-cover-item">
                                <img class="touch-target" :src="getCoverPath(articleListMV[0].cover)" alt="">
                            </div>
                        </div>
                        <div class="article-info">
                            <div class="article-info-box">
                                <div @click="goto_url(articleListMV[0].defaultLink)" class="article-title">{{ articleListMV[0].title }}</div>
                                <div class="article-date">
                                    {{ dateStrFormat(articleListMV[0].releaseDate) }}
                                    <img class="touch-target" v-for="linkItem, index in articleListMV[0].linkList"
                                    :key="'MV' + articleListMV[0].id + '-linkList-' + index"
                                    @click="goto_url(linkItem.link)"
                                    :src="getCoverPath(linkItem.logo)" alt="">
                                </div>
                                <div class="article-abstract">{{ articleListMV[0].articleAbstract }}</div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="skeleton">
                        <div class="article-skeleton" v-for="i in 1" :key="'MarketView-skeleton-' + i">
                            <div class="cover-skeleton">
                                <img src="../../assets/image/index_v2/cover_load.svg" alt="">
                            </div>
                            <div class="context-skeleton">
                                <div class="title-skeleton"></div>
                                <div class="date-skeleton"></div>
                                <div class="abstract-skeleton"></div>
                                <div class="abstract-skeleton"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div @click="page_turning(true)" class="down-svg">
            <img src="../../assets/image/index_v2/down.svg" alt="">
        </div>
        <div class="btm-box">
            <div class="contact-info">
                <div class="y-line"></div>
                <div class="contact-item">
                    <span>For inquiries please contact info</span>&nbsp;<span class="contact-item-w">contact@lucida.fund</span>
                </div>
                <div class="contact-item">
                    <span>Exceptional people should contact</span>&nbsp;<span class="contact-item-w">work@lucida.fund</span>
                </div>
            </div>
            <div class="subscribe">
                <div class="subscribe-text">
                    <div>Stay on top of crypto. All the time, any time.</div>
                    <div>
                        <span>Please keep me updated by email with the latest crypto news, research findings,</span><br />
                        <span>reward programs, event updates, coin listings and more information from LUCIDA.</span>
                    </div>
                </div>
                <div class="subscribe-email">
                    <input v-model="email" type="email" placeholder="Enter your e-mail address">
                    <button @click="subscribeMessage">Subscribe</button>
                </div>
            </div>
        </div>
        <div class="line"></div>
        <div class="bottom-info">
            <div class="bottom-info-left">
                <span>Copyright 2025</span>
                <img class="jump-to" @click="goto_url('https://x.com/lucidafund')" src="../../assets/image/index_v2/Group 27153.svg" alt="">
                <img class="jump-to" @click="goto_url('https://mirror.xyz/lucidafund.eth')" src="../../assets/image/index_v2/Group 27154.svg" alt="">
                <img class="jump-to" @click="goto_url('https://www.linkedin.com/company/81970900')" src="../../assets/image/index_v2/Group 27157.svg" alt="">
                <img class="jump-to" @click="goto_url('https://medium.com/@Lucida_and_Falcon')" src="../../assets/image/index_v2/Group 27156.svg" alt="">
                <img class="jump-to" @click="goto_url('https://github.com/lucidagithub')" src="../../assets/image/index_v2/Group 27158.svg" alt="">
            </div>
            <div class="bottom-info-right">
                Lucida's funds are registered in the Cayman Islands.<br />
                Lucida does not solicit or accept retail investment.<br />
                <hr>
            </div>
        </div>
    </div>
</template>

<style scoped>
    @font-face {
        font-family: "MiSans-Bold";
        src: url("../../assets/fonts/index_v2/MiSans/ttf/MiSans-Bold.ttf");
    }
    @font-face {
        font-family: "MiSans-Regular";
        src: url("../../assets/fonts/index_v2/MiSans/ttf/MiSans-Regular.ttf");
    }
    @font-face {
        font-family: "MiSans-Demibold";
        src: url("../../assets/fonts/index_v2/MiSans/ttf/MiSans-Demibold.ttf");
    }
    .container {
        width: 92%;
        height: 100%;
        margin-left: 4%;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .main-box {
        position: relative;
        margin-top: 8%;
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .lucida-icon{
        transition: transform 0.6s ease;
    }
    .lucida-icon > img{
        width: 200px;
    }
    .title {
        font-family: MiSans-Bold;
        font-size: 82px;
        line-height: 124px;
        transition: transform 0.6s ease, opacity 0.6s ease;
    }
    .title>div{
        display: flex;
        align-items: center;
        overflow: hidden;
    }
    .up-svg, .down-svg{
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 10px 0;
        width: 30px;
        height: 30px;
        z-index: 999;
        overflow: hidden;
        cursor: pointer;
        user-select: none;
        opacity: 1;
    }
    .up-svg {
        display: none;
        transform: rotate(180deg);
        transform-origin: center;
    }
    .up-svg-box{
        width: 100%;
        display: flex;
        justify-content: center;
        position: absolute;
        top: -100px;
    }
    .up-svg img, .down-svg img{
        filter: drop-shadow(#fff 200px 0);
        transform: translateX(-200px);
    }
    .line{
        width: 100%;
        height: 1px;
        background-color: #fffa;
    }
    hr {
        background-color: #fffa;
        height: 1px;
        border: none;
    }
    .emphasize {
        background-color: #0045FF;
    }
    .bottom-info {
        font-family: MiSans-Regular;
        font-size: 16px;
        margin: 10px 0;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .bottom-info-left {
        display: flex;
        align-items: center;
    }
    .bottom-info-left>span{
        margin-right: 16px;
        opacity: .6;
    }
    .bottom-info-left>img{
        width: 28px;
        cursor: pointer;
        user-select: none;
        margin-right: 12px;
    }
    .bottom-info-right {
        text-align: right;
        line-height: 20px;
    }
    .btm-box {
        position: relative;
        width: 100%;
    }
    .contact-info {
        position: relative;
        margin-bottom: 50px;
        width: 100%;
        font-size: 18px;
        opacity: 0;
        transition: opacity 0.6s ease;
    }
    .contact-item{
        font-family: MiSans-Regular;
        display: inline-block;
        margin-right: 8%;
    }
    .contact-item>span:nth-child(1){
        margin-left: 14px;
    }
    .contact-item-w{
        font-family: MiSans-Bold;
        cursor: pointer;
        color: #0045FF;
    }
    .y-line {
        position: absolute;
        bottom: 2px;
        width: 1px;
        height: 140px;
        background-color: #fffa;
    }
    .user-info{
        font-family: MiSans-Regular;
        position: absolute;
        text-align: right;
        right: 0;
        opacity: 0;
        transition: opacity 0.6s ease;
        font-size: 26px;
        line-height: 30px;
        overflow: hidden;
    }
    .user-info span {
        font-family: MiSans-Bold;
    }
    .info-item{
        margin-top: 24px;
    }
    .article {
        width: 100%;
        position: absolute;
        top: 0;
        display: none;
        gap: 60px;
        opacity: 0;
        transition: opacity 0.6s ease;
    }
    .article-research{
        flex: 1;
        margin-left: 14px;
    }
    .article-apmv{
        flex: 1;
        margin: -66px 14px 0 0;
    }
    .article-type{
        font-size: 35px;
        height: 66px;
        line-height: 66px;
        overflow: hidden;
        font-family: MiSans-Demibold;
    }
    .article-list{
        overflow-y: scroll;
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
    .article-list-left{
        max-height: 484px;
    }
    .article-list-right{
        max-height: 360px;
    }
    /* 自定义滚动条 */
    .article-list::-webkit-scrollbar {
        width: 2px;
    }
    .article-list::-webkit-scrollbar-track {
        background: #484848;
    }
    .article-list::-webkit-scrollbar-thumb {
        background: #fff;
    }
    /* 自定义滚动条 */
    .article-item{
        display: flex;
    }
    .article-cover {
        border: 1px solid #fff;
        border-radius: 8px;
        overflow: hidden;
    }
    .cover-line{
        width: 100%;
        border-bottom: 1px solid #fff;
    }
    .article-line{
        width: 100%;
        height: 1px;
    }
    .article-cover-item{
        width: 220px;
        height: 114px;
        overflow: hidden;
        cursor: pointer;
        object-fit: cover;
    }
    .article-cover-item>img{
        width: 100%;
    }
    .article-info{
        font-family: MiSans-Regular;
        flex: 1;
        margin: 0 12px;
    }
    .article-info-box{
        height: 115px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }
    .article-title{
        font-family: MiSans-Regular;
        font-size: 18px;
        line-height: 22px;
        cursor: pointer;
    }
    .article-title, .article-abstract{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .article-abstract, .article-date{
        font-size: 12px;
        line-height: 16px;
    }
    .article-date{
        display: flex;
        align-items: center;
    }
    .article-date > img{
        width: 14px;
        height: 14px;
        margin-left: 6px;
        cursor: pointer;
    }
    .subscribe {
        position: absolute;
        bottom: 14px;
        width: 100%;
        display: flex;
        opacity: 0;
        transition: opacity 0.6s ease;
    }
    .subscribe-text>div:nth-child(1){
        font-family: MiSans-Demibold;
        font-size: 35px;
        margin-bottom: 8px;
    }
    .subscribe-text>div:nth-child(2){
        font-family: MiSans-Regular;
        font-size: 18px;
    }
    .subscribe-text {
        flex: 1;
        margin-left: 14px;
    }
    .subscribe-email{
        flex: 1;
        margin-right: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: MiSans-Regular;
    }
    .subscribe-email>input {
        width: 320px;
        height: 42px;
        padding: 0px 12px;
        outline: none;
        border: 0px;
        border-radius: 12px;
        color: #909090;
        background-color: #d9d9d9;
        font-size: 18px;
    }
    .subscribe-email>button {
        width: 110px;
        height: 42px;
        margin-left: 8px;
        color: #fff;
        border: 0px;
        border-radius: 12px;
        background-color: #0045FF;
        cursor: pointer;
        font-size: 16px;
    }
    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .next-page{
        display: flex;
        justify-content: center;
    }
    .next-page>span{
        font-family: MiSans-Regular;
        font-size: 12px;
    }
    .next-page>img {
        width: 20px;
        height: 20px;
        animation: spin 1.5s linear infinite;
    }
    .skeleton{
        width: 100%;
    }
    .article-skeleton {
        display: flex;
        margin-bottom: 8px;
    }
    .cover-skeleton {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 220px;
        height: 110px;
        border-radius: 8px;
        background-color: #666;
    }
    .cover-skeleton>img{
        width: 30px;
        height: 30px;
    }
    .context-skeleton{
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    .title-skeleton, .date-skeleton, .abstract-skeleton{
        margin: 0 8px;
        border-radius: 4px;
        background-color: #666;
    }
    .title-skeleton {
        flex: 1;
    }
    .date-skeleton, .abstract-skeleton {
        height: 18px;
    }
    .date-skeleton{
        width: 70%;
    }
    @media screen and (max-width:1440px){
        .main-box {
            margin-top: 12%;
        }
    }
    @media screen and (min-width:1200px) and (max-width:1440px){
        .title {
            font-size: 70px;
            line-height: 100px;
        }
        .user-info{
            font-size: 20px;
            line-height: 26px;
        }
        .contact-info {
            margin-bottom: 20px;
        }
        .y-line {
            height: 120px;
        }
        .contact-item {
            margin-right: 4%;
        }
        .article-apmv{
            margin-top: -50px;
        }
        .article-type{
            font-size: 28px;
            height: 50px;
            line-height: 50px;
        }
        .subscribe-text>div:nth-child(1){
            font-size: 24px;
        }
        .subscribe-text>div:nth-child(2){
            font-size: 12px;
            line-height: 18px;
        }
    }
    @media screen and (max-width:1200px){
        .title {
            font-size: 60px;
            line-height: 90px;
        }
        .user-info{
            font-size: 18px;
            line-height: 20px;
        }
        .contact-info {
            margin-bottom: 16px;
        }
        .y-line {
            height: 100px;
        }
        .contact-item {
            font-size: 14px;
            margin-right: 1%;
        }
        .bottom-info{
            font-size: 14px;
        }
        .bottom-info-left>img{
            width: 24px;
        }
        .article-type{
            height: 40px;
            line-height: 40px;
            font-size: 24px;
            overflow: hidden;
        }
        .article-apmv{
            margin-top: -40px;
        }
        .article-title{
            font-size: 14px;
            line-height: 18px;
        }
    }
    @media screen and (min-width:1024px) and (max-width:1200px){
        .subscribe-text>div:nth-child(1) {
            font-size: 22px;
        }
        .subscribe-text>div:nth-child(2) {
            font-size: 12px;
        }
    }
    @media screen and (max-width:1024px){
        .subscribe-text>div:nth-child(1) {
            font-size: 20px;
        }
        .subscribe-text>div:nth-child(2) {
            font-size: 10px;
        }
    }
    @media screen and (max-height:800px){
        .article-cover-item{
            width: 190px;
            height: 100px;
        }
        .cover-skeleton {
            width: 190px;
            height: 100px;
        }
    }
    @media screen and (min-height:660px) and (max-height:800px){
        .article-list-left{
            max-height: 360px;
        }
        .article-list-right{
            max-height: 252px;
        }
        .article-info-box{
            height: 101px;
        }
        .article-type{
            font-size: 28px;
            height: 50px;
            line-height: 50px;
        }
        .article-apmv{
            margin-top: -50px;
        }
    }
    @media screen and (max-height:660px){
        .lucida-icon > img{
            width: 160px;
        }
        .title{
            font-size: 50px;
            line-height: 80px;
        }
        .info-item {
            margin-top: 18px;
        }
        .article-list-left{
            max-height: 280px;
        }
        .article-list-right{
            max-height: 182px;
        }
        .article-info-box{
            height: 101px;
        }
        .article-type{
            height: 40px;
            line-height: 40px;
            font-size: 24px;
            overflow: hidden;
        }
        .article-apmv{
            margin-top: -40px;
        }
        .bottom-info{
            margin: 0;
        }
        hr {
            margin: 4px 0px;
        }
    }
    @media (max-width:1200px) or (max-height:760px){
        .subscribe-email>input {
            width: 220px;
            height: 32px;
            font-size: 14px;
            border-radius: 6px;
        }
        .subscribe-email>button {
            width: 80px;
            height: 32px;
            font-size: 12px;
            border-radius: 6px;
        }
    }
</style>

<script>
export default {
  data() {
    return {
        pageCount: 0,
        pageTotal: 3,
        startX: 0,
        startY: 0,
        isHandleScroll: false,
        timerId: null,
        articleListR: [],
        articleR: [],
        articleListAMAP: [],
        articleAMAP: [],
        articleListMV: [],
        rollerY: null,
        email: "",
        mouseInList: 0,
        articleListParam: {
            "Research": {
                currentPage: 1,
                pageSize: 10,
                total: 0,
                state: 0
            },
            "AMA & Podcast": {
                currentPage: 1,
                pageSize: 10,
                total: 0,
                state: 0
            },
            "Market View": {
                currentPage: 1,
                pageSize: 10,
                total: 0,
                state: 0
            },
        }
    };
  },
  watch: {
    pageCount(newValue, oldValue){
        let down = document.querySelector('.down-svg');
        let up = document.querySelector('.up-svg');
        let lucidaIcon = document.querySelector(".lucida-icon");
        let title = document.querySelector(".title");
        let userInfo = document.querySelector(".user-info");
        let contactInfo = document.querySelector(".contact-info");
        let subscribe = document.querySelector(".subscribe");
        let article = document.querySelector(".article");
        let state = oldValue + "->" + newValue;
        switch (state) {
            case "1->0": {
                down.style.opacity = '1';
                down.style.cursor = 'pointer';
                up.style.display = 'none';
                lucidaIcon.style.transform = 'translateY(0)';
                title.style.transform = 'translateX(0)';
                title.style.opacity = '1';
                userInfo.style.opacity = '0';
                contactInfo.style.opacity = '0';
                subscribe.style.opacity = '0';
                article.style.opacity = '0';
                setTimeout(() => {
                    article.style.display = 'none';
                }, 600);
                break;
            }
            case "0->1":
            case "2->1": {
                down.style.opacity = '1';
                down.style.cursor = 'pointer';
                up.style.display = 'flex';
                let rect = lucidaIcon.getBoundingClientRect(); // 计算偏移量
                if(oldValue === 0) {
                    let h = document.body.clientHeight * 0.07;
                    lucidaIcon.style.transform = `translateY(-${rect.top-h}px)`;
                }
                rect = title.getBoundingClientRect(); // 计算偏移量
                let w = document.body.clientWidth * 0.04;
                if(oldValue === 0){
                    title.style.transform = `translateX(-${rect.left-w}px)`;
                }
                title.style.opacity = '0.5';
                userInfo.style.opacity = '1';
                contactInfo.style.opacity = '1';
                subscribe.style.opacity = '0';
                article.style.opacity = '0';
                setTimeout(() => {
                    article.style.display = 'none';
                }, 600);
                break;
            }
            case "1->2": {
                down.style.opacity = '0';
                down.style.cursor = 'auto';
                up.style.display = 'flex';
                title.style.opacity = '0';
                userInfo.style.opacity = '0';
                contactInfo.style.opacity = '0';
                subscribe.style.opacity = '1';
                setTimeout(() => {
                    article.style.display = 'flex';
                    setTimeout(() => {
                        article.style.opacity = '1';
                    }, 10);
                }, 10);
                break;
            }
        }
    },
    email(newValue, oldValue){
        let btnDom = document.querySelector(".subscribe-email button");
        btnDom.innerHTML = "Subscribe";
        btnDom.style.backgroundColor = "#0045FF";
        btnDom.style.color = "#fff";
    }
  },
  methods: {
    mouseInListEnter(value) {
        this.mouseInList = value;
        this.isHandleScroll = true;
    },
    mouseInListLeave() {
        this.mouseInList = 0;
        this.isHandleScroll = false;
    },
    touchInList(targetClass){
        // console.log(targetClass);
        let list = ['touch-target', 'article-info-box', 'article-title', 'article-date', 'article-abstract'];
        if(list.includes(targetClass)) return true;
        else return false;
    },
    touchStartHandler(e) {
        if(this.touchInList(e.target.className)) this.isHandleScroll = true;
        else this.isHandleScroll = false;
        this.startX = e.changedTouches[0].pageX,
        this.startY = e.changedTouches[0].pageY;
    },
    touchEndHandler(e) {
        if(this.isHandleScroll) return;
        let x = e.changedTouches[0].pageX - this.startX;
        let y = e.changedTouches[0].pageY - this.startY;
        let abs_x = (x > 0 ? x : -x);
        let abs_y = (y > 0 ? y : -y);
        // 当 |y| > |x| 时，为上/下滑 ( |y|必需大于最小滑动值 )
        if(abs_y > abs_x && abs_y > 30 && this.timerId === null) {
            if(y < 0 && this.pageCount < (this.pageTotal - 1)) {
                this.timerId = setTimeout(() => {
                    this.timerId = null;
                }, 600);
                this.pageCount++;
            }
            else if(y > 0 && this.pageCount > 0) {
                this.timerId = setTimeout(() => {
                    this.timerId = null;
                }, 600);
                this.pageCount--;
            }
        }
    },
    getCoverPath(path) {
        return this.fileServer + "/article" + path;
    },
    logTimeWithMs() {
        const now = new Date();
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');
        const milliseconds = now.getMilliseconds().toString().padStart(3, '0');
        return `${hours}:${minutes}:${seconds}.${milliseconds}`;
    },
    isTouchSupported(){
        const isTouchSupported = 'ontouchstart' in window || 
                         (navigator.maxTouchPoints > 0) || 
                         (navigator.msMaxTouchPoints > 0);
        return isTouchSupported;
    },
    roll_away(e) {
        if(this.isTouchSupported() && this.isHandleScroll) {
            return;
        }
        // 阻止滚动翻页事件
        if (this.mouseInList) return;
        console.log("rollerY", this.rollerY, this.logTimeWithMs());
        // 小于100的值滚动叠加
        if(this.rollerY===null||this.rollerY>0&&e.deltaY<0||this.rollerY<0&&e.deltaY>0) {
            this.rollerY = e.deltaY;
        } else {
            this.rollerY += e.deltaY;
        }
        // 滚动翻页
        if(this.rollerY >= 100 && this.pageCount < (this.pageTotal - 1)) {
            this.rollerY = 0;
            if(this.timerId === null) {
                this.timerId = setTimeout(() => {
                    this.timerId = null;
                }, 600);
                this.pageCount++;
                console.log("pageCount", this.pageCount, this.logTimeWithMs());
            }
        }
        else if(this.rollerY <= -100 && this.pageCount > 0) {
            this.rollerY = 0;
            if(this.timerId === null) {
                this.timerId = setTimeout(() => {
                    this.timerId = null;
                }, 600);
                this.pageCount--;
                console.log("pageCount", this.pageCount, this.logTimeWithMs());
            }
        }
    },
    page_turning(side) {
        this.rollerY = null;
        if(this.timerId === null) {
            if (side && this.pageCount < (this.pageTotal - 1)) {
                this.timerId = setTimeout(() => {
                    this.timerId = null;
                }, 600);
                this.pageCount++;
            }
            else if(!side && this.pageCount > 0) {
                this.timerId = setTimeout(() => {
                    this.timerId = null;
                }, 600);
                this.pageCount--;
            }
        }
    },
    goto_url(url) {
        if(url) window.open(url);
    },
    handleScroll(type) {
        if(this.isTouchSupported()) this.isHandleScroll = true;
        let container = null;
        if(type === 'Research') container = this.$refs.ResearchScroll;
        else if(type === 'AMA & Podcast')  container = this.$refs.AMAPodcastScroll;
        else return;
        // 检查是否滚动到底部（允许2px的误差）
        if (container.scrollHeight - container.scrollTop <= container.clientHeight + 2) {
            this.nextPage(type);
        }
    },
    isLastPage(type) {
        let param = this.articleListParam[type];
        switch (type) {
            case "Research":
                return (this.articleListR.length+1) >= param.total;
            case "AMA & Podcast":
                return (this.articleListAMAP.length+1) >= param.total;
            default:
                return true;
        }
    },
    dateStrFormat(dateStr){
        let ymd = dateStr.split(" ")[0].split("-");
        return `${ymd[2]}/${ymd[1]}/${ymd[0]}`;
    },
    stringToDate(dateStr) {
        return new Date(dateStr);
    },
    whoIsZh(text1,text2){
        const t1 = (text1.match(/[\u4e00-\u9fa5]/g) || []).length;
        const t2 = (text2.match(/[\u4e00-\u9fa5]/g) || []).length;
        if(t1 > t2) return 0;
        else return 1;
    },
    articleGroup(articleList) {
        let _articleList = articleList.sort((a, b) => this.stringToDate(b.releaseDate) - this.stringToDate(a.releaseDate));
        let articleGroupData = {};
        for(let item of _articleList) {
            let key = '' + item.groupId;
            if(!articleGroupData[key]) {
                articleGroupData[key] = {
                    "groupId": item.groupId,
                    "cover": [],
                    "articleList": []
                };
            }
            articleGroupData[key]["cover"].push(item.cover);
            articleGroupData[key]["articleList"].push(item);
        }
        let articleGroupList = Object.values(articleGroupData);
        // 强制将英文文章排在上面
        let temp, i, j;
        for(i in articleGroupList) {
            if(articleGroupList[i]['articleList'].length === 2){
                j = this.whoIsZh(
                    articleGroupList[i]['articleList'][0].articleAbstract,
                    articleGroupList[i]['articleList'][1].articleAbstract
                );
                // 交换位置
                if (j === 0) {
                    temp = articleGroupList[i]['cover'][0];
                    articleGroupList[i]['cover'][0] = articleGroupList[i]['cover'][1];
                    articleGroupList[i]['cover'][1] = temp;
                    temp = articleGroupList[i]['articleList'][0];
                    articleGroupList[i]['articleList'][0] = articleGroupList[i]['articleList'][1];
                    articleGroupList[i]['articleList'][1] = temp;
                }
            }
        }
        // 分组排序
        articleGroupList = articleGroupList.sort((a, b) => this.stringToDate(b.articleList[1].releaseDate) - this.stringToDate(a.articleList[1].releaseDate));
        return articleGroupList;
    },
    async getArticleList(params){
        let state = this.articleListParam[params.type].state;
        if(state) return;
        this.articleListParam[params.type].state = 1;
        await this.request({
            method: 'GET',
            url: '/article/getArticleList',
            params: params
        }).then((res)=>{
            if(res.data.code===200) {
                let dataList = res.data.data;
                for(let index in dataList) {
                    dataList[index].linkList = JSON.parse(dataList[index].linkUrl);
                }
                switch (params.type) {
                    case "Research":
                        this.articleListR = this.articleListR.concat(dataList);
                        this.articleR = this.articleR.concat(this.articleGroup(dataList));
                        break;
                    case "AMA & Podcast":
                        this.articleListAMAP = this.articleListAMAP.concat(dataList);
                        this.articleAMAP = this.articleAMAP.concat(this.articleGroup(dataList));
                        break;
                    case "Market View":
                        this.articleListMV = this.articleListMV.concat(dataList);
                        break;
                    default:
                        break;
                }
            }
        });
        await this.request({
            method: 'GET',
            url: '/article/getArticleCount',
            params: {
                type: params.type
            }
        }).then((res)=>{
            this.articleListParam[params.type].total = res.data.data;
        });
        let type = params.type;
        setTimeout(() => {
            this.articleListParam[type].state = 0;
        }, 600);
    },
    nextPage(type) {
        if(type === '' || this.isLastPage(type)) return;
        this.articleListParam[type].currentPage++;
        let params = {
            type: type,
            currentPage: this.articleListParam[type].currentPage,
            pageSize: this.articleListParam[type].pageSize
        }
        this.getArticleList(params);
    },
    subscribeMessage() {
        if (!this.email) return;
        this.request({
            method: 'POST',
            url: '/mail_push/subscribe',
            data: {
                email: this.email
            }
        }).then((res)=>{
            let btnDom = document.querySelector(".subscribe-email button");
            if(res.data.code === 200) {
                btnDom.innerHTML = "Subscribed";
                btnDom.style.backgroundColor = "#fff";
                btnDom.style.color = "#000";
            } else if(res.data.code === 202) {
                btnDom.innerHTML = "Duplicate<br/>Subscription";
                btnDom.style.backgroundColor = "#515151";
                btnDom.style.color = "#fff";
            }
        });
    }
  },
  async created() {
    await this.getArticleList({
        type: "Research",
        currentPage: 1,
        pageSize: this.articleListParam["Research"].pageSize
    });
    await this.getArticleList({
        type: "AMA & Podcast",
        currentPage: 1,
        pageSize: this.articleListParam["AMA & Podcast"].pageSize
    });
    await this.getArticleList({
        type: "Market View",
        currentPage: 1,
        pageSize: this.articleListParam["Market View"].pageSize
    });
  }
};
</script>